<template>
	<div class="page-login">
		<div class="container">
			<div class="login-logo text-center">
				<picture>
					<img src="/img/logo/grafias_medium_ondark.png" class="d-inline-block m-auto" loading="lazy" alt="Grafias">
				</picture>
			</div>
			<div class="login-box card magic-link-box" v-if="!isCreated">
				<div class="login-box-content">
					<div class="login-error callout callout--danger hidden" v-if="loginError">
						<div class="callout__content">{{ loginError }}</div>
					</div>
					<form @submit.prevent="send">
						<div class="mb-3">
							<h2 class="font-weight-normal">{{ $t('Forgot Password') }}</h2>
						</div>
						<div class="text-small mb-3">
							{{ $t('Please enter your registered email below, we will send the link to login, and if you choose to reset your password we will reset it for you and you need to change your password after you logged in') }}
						</div>
						<!-- Email -->
						<div class="form-group">
							<label>{{ $t('Email') }}</label>
							<input type="email" name="email" class="form-control" v-model="email" required>
						</div>
						<label class="custom-control custom-checkbox mb-4">
							<input type="checkbox" class="custom-control-input" v-model="isForgot">
							<span class="custom-control-label">{{ $t('I totally forgot my password, please reset it') }}</span>
						</label>
						<!-- Submit -->
						<button
							type="submit"
							class="btn btn-submit btn-primary"
							:class="{ 'is-loading': isSending }">
							{{ $t('SEND LOGIN LINK') }}
						</button>
						<div class="login-extra d-flex justify-content-between align-items-center mt-5">
							<router-link class="login-action mr-2" to="/login">{{ $t('Back To Login') }}</router-link>
						</div>
					</form>
				</div>
			</div>
			<div class="message-box text-center" v-else>
				<h3 class="mb-5">{{ messageSuccess }}</h3>
				<router-link
					to="/login"
					class="btn btn-submit btn-primary mt-3">
					{{ $t('Back To Login') }}
				</router-link>
			</div>
		</div>
		<div class="modals">
			<!-- Login Error -->
			<modal
				class="login-error-modal"
				size="small"
				@close="error = false"
				v-if="error">
				<div slot="header">{{$t('Login Error')}}</div>
				<div slot="body" class="text-left">
					<div v-if="errorMessage === ''">{{ $t('Wrong Email or Password') }}</div>
					<div v-else>{{ errorMessage }}</div>
				</div>
				<div slot="footer">
					<button type="button" class="btn btn-secondary" @click="error = false">OK</button>
				</div>
			</modal>
		</div>
		<footer
			class="footer footer-main">
			<div class="d-flex justify-content-between">
				<div>
					<div class="footer-brand text-grey"><span>{{ $t('Ver.') }} {{ appVersion }}</span></div>
				</div>
			</div>
		</footer>
	</div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { getAxiosErrorMessage } from '../lib/helper';
import Modal from '../components/Modal.vue';
import auth from '../api/auth';
import {
	appVersion,
} from '@/lib/statics';

export default {
	name: 'MagicLink',
	components: {
		Modal,
	},
	data() {
		return {
			email: '',
			password: '',
			isShowResetPassword: false,
			isResettingPassword: false,
			resetPasswordError: false,
			resetPasswordSuccess: false,
			error: false,
			errorMessage: '',
			languageLabel: {
				en: 'English',
				no: 'Norsk',
			},
			isForgot: false,
			isSending: false,
			isCreated: false,
			messageSuccess: '',
		};
	},
	methods: {
		...mapActions({
			setLocale: 'setLocale',
		}),
		send() {
			this.isSending = true;
			const email = this.email.trim();
			const params = {
				email,
				lang: 'en',
			};
			const callback = (response) => {
				const message = response.message;
				this.messageSuccess = message;
				// this.$notify({
				// 	group: 'app',
				// 	type: 'success',
				// 	title: 'Magic Link',
				// 	text: message,
				// });
				this.isSending = false;
				this.isCreated = true;
			};
			const errorCallback = (e) => {
				const message = getAxiosErrorMessage(e);
				this.$notify({
					group: 'app',
					type: 'error',
					title: 'Magic Link',
					text: message,
				});
				this.isSending = false;
			};
			if (this.isForgot) {
				auth.forgotPassword(params, callback, errorCallback);
			} else {
				auth.generate(params, callback, errorCallback);
			}
		},
		setLanguage(lang) {
			this.$router.push({ query: { lang } }).catch(() => {});
		},
	},
	computed: {
		...mapGetters({
			user: 'user',
			locale: 'locale',
			isLoggingIn: 'isLoggingIn',
			loginError: 'loginError',
		}),
		action() {
			const { action } = this.$route.query;
			return action;
		},
		lang() {
			const lang = this.$route.query.lang || this.locale;
			return lang;
		},
		appVersion() {
			return appVersion;
		},
	},
	watch: {
		loginError(loginError) {
			if (loginError) {
				this.error = true;
				this.errorMessage = loginError;
			}
		},
	},
	created() {
	},
	destroyed() {
	},
};
</script>
